<div class="max-w-md mx-auto mt-10 p-6 bg-white rounded-2xl shadow space-y-4">
    <h2 class="text-xl font-bold text-gray-800 text-center">
        🎨 Mise à jour du template mC-Connect™
    </h2>

    <!-- Affichage de l'image actuelle récupérée -->
    <div class="flex justify-center">
        <img *ngIf="imageSrc && !isImageRefreshing" [src]="imageSrc" alt="Image actuelle"
            class="my-4 max-w-xs rounded-xl shadow" />

        <!-- 🔁 Roue de chargement -->
        <div *ngIf="isImageRefreshing" class="my-4">
            <svg class="animate-spin h-8 w-8 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
        </div>
    </div>


    <div class="space-y-2">
        <label class="block text-sm font-medium text-gray-700">📝 Message affiché</label>
        <input type="text" [(ngModel)]="templateMessage" placeholder="Ex: You can order from your smartphone."
            class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-indigo-200" />
    </div>

    <div class="space-y-2">
        <label class="block text-sm font-medium text-gray-700">🔗 URL du QR Code</label>
        <input type="text" [(ngModel)]="templateUrl" placeholder="Ex: https://tonsite.com"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-indigo-200" />
    </div>

    <button (click)="updateDeviceWithTemplate()"
        class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200">
        ✅ Mettre à jour la phrase et le QR Code
    </button>

    <div class="space-y-2">
        <label class="block text-sm font-medium text-gray-700">🔗 URL du QR Code</label>
        <input type="file" (change)="onFileSelected($event)" accept="image/png"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-indigo-200" />
    </div>

    <!-- Message d'erreur (rouge) -->
    <div *ngIf="errorMessage" class="mt-4 p-4 rounded-xl bg-red-100 border border-red-400 text-red-800 shadow-md">
        {{ errorMessage }}
    </div>

    <!-- Message d'avertissement (jaune) -->
    <div *ngIf="warnMessage"
        class="mt-4 p-4 rounded-xl bg-yellow-100 border border-yellow-400 text-yellow-800 shadow-md">
        {{ warnMessage }}
    </div>
</div>